module.exports = __webpack_public_path__ + "static/media/checked_icon.bac222d7.svg";